import { Children, cloneElement } from 'react';
import { Size } from '@optimus-web/common';
import { SegmentedControlItemProps } from '../SegmentedControlItem';
import { SegmentedControlStack } from './style';

export type SegmentedControlChild = React.ReactElement<SegmentedControlItemProps>;

export interface SegmentedControlProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
    children:
        | SegmentedControlChild
        | ((SegmentedControlChild | null)[] & {
              0?: SegmentedControlChild | null;
              1?: SegmentedControlChild | null;
              2?: SegmentedControlChild | null;
              3?: SegmentedControlChild | null;
              4?: SegmentedControlChild | null;
              length: 0 | 1 | 2 | 3 | 4 | 5;
          } & (
                  | { 0: SegmentedControlChild }
                  | { 1: SegmentedControlChild }
                  | { 2: SegmentedControlChild }
                  | { 3: SegmentedControlChild }
                  | { 4: SegmentedControlChild }
              ));
    onChange: (e: React.MouseEvent<HTMLButtonElement>, value: string) => void;
    value?: boolean | string | number;
    name?: string;
    disabled?: boolean;
    className?: string;
    size?: Size;
    itemWidth?: 'evenly' | 'content';
}

export const SegmentedControl = ({
    children,
    value,
    name,
    disabled,
    className,
    size = 'medium',
    itemWidth = 'evenly',
    onChange,
    ...other
}: SegmentedControlProps) => (
    <SegmentedControlStack
        className={className}
        size={size}
        role="radiogroup"
        spacing="25"
        distribution="space-between"
        {...other}
    >
        {Children.map(
            children,
            (child) =>
                child &&
                cloneElement(child, {
                    disabled: disabled || child.props.disabled,
                    checked: child.props.value === value,
                    name,
                    itemWidth,
                    onChange,
                    ...child.props,
                })
        )}
    </SegmentedControlStack>
);
